export default {"src":"/_next/static/media/united-arab-emirates.6b73dd94.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};